export default __webpack_public_path__ + "static/media/Provence.6bd7fe8b.jpg";